import React from 'react';
// Components
import PlaySectionOne from './PlaySectionOne';
import PlaySectionTwo from './PlaySectionTwo';
import PlaySectionThree from './PlaySectionThree';
import ContactCard from '../contact/ContactCard';
// Images
import FlowerBanner from '../../assets/images/temp/flower-banner-background.svg';
import CallToActionOne from '../cta/CallToActionOne';
import SmallGalleryComponent from '../gallery/SmallGalleryComponent';
import SmallSocialCta from '../socialMedia/SmallSocialCta';

function HomePageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full'>
      <div className='sm:px-6 md:px-10 lg:px-20'>
        <PlaySectionOne />
      </div>

      {/* Banner */}
      <div className='pt-12 pb-8 lg:pt-16 lg:pb-12'>
        <ContactCard />
      </div>

      <div className='mb-12 sm:px-6 md:px-10 lg:px-20'>
        <PlaySectionTwo />
      </div>

      <div
        style={{
          backgroundImage: `url(${FlowerBanner})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
        className='sm:px-6 md:px-10 lg:px-20'
      >
        <PlaySectionThree />
      </div>

      {/* Cta */}
      <div className='py-2'>
        <CallToActionOne />
      </div>

      {/* Small gallery */}
      <div className='pt-4'>
        <SmallGalleryComponent />
      </div>

      <div className='py-8 lg:py-12 xl:py-16'>
        <SmallSocialCta />
      </div>
    </main>
  );
}

export default HomePageMainContainer;
